import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from './Card';

interface StatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  trend?: {
    value: number;
    label: string;
    isPositive?: boolean;
  };
  iconColor?: string;
  loading?: boolean;
}

export function StatCard({ title, value, icon: Icon, trend, iconColor = 'bg-blue-100 text-blue-600', loading }: StatCardProps) {
  if (loading) {
    return (
      <Card>
        <div className="animate-pulse">
          <div className="flex items-center justify-between mb-4">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
          </div>
          <div className="h-8 bg-gray-200 rounded w-32 mb-2"></div>
          {trend && <div className="h-3 bg-gray-200 rounded w-20"></div>}
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <div className={`p-2.5 rounded-lg ${iconColor}`}>
          <Icon size={20} />
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-3xl font-bold text-gray-900">{value}</p>
        {trend && (
          <div className="flex items-center gap-1.5">
            {trend.isPositive !== undefined && (
              trend.isPositive ? (
                <TrendingUp size={16} className="text-green-600" />
              ) : (
                <TrendingDown size={16} className="text-red-600" />
              )
            )}
            <span className={`text-sm font-medium ${
              trend.isPositive === undefined ? 'text-gray-600' :
              trend.isPositive ? 'text-green-600' : 'text-red-600'
            }`}>
              {trend.value > 0 && '+'}{trend.value}% {trend.label}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
}
